// @flow weak
import ReactDOM from 'react-dom';
import _ from 'lodash';

export const setRef = (Component, key) => nodeOrComponent => {
  // The ref might be a real DOM node _or_ a representation of a component
  _.set(Component, ['dangerousRefs', key], nodeOrComponent);
};

export const getRef = (Component, key) =>
  // Regardless of whether the ref is a real DOM node or a component,
  // always return the representative DOM node.
  ReactDOM.findDOMNode(_.get(Component, ['dangerousRefs', key]));
